import { render, staticRenderFns } from "./InventoryBuyerSupplierGroup.vue?vue&type=template&id=9882c310&"
import script from "./InventoryBuyerSupplierGroup.vue?vue&type=script&lang=js&"
export * from "./InventoryBuyerSupplierGroup.vue?vue&type=script&lang=js&"
import style0 from "./InventoryBuyerSupplierGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports